<template>
    <div class="text-center">
      <v-dialog v-model="dialog" max-width="700" persistent>
        <v-card>
          <v-card-title class="text-h5 red darken-3 white--text">
            Reporte
          </v-card-title>
  
          <v-card-text> 
            <div class="row">
                <div class="col-sm-12">
                    <div class="xcard">
                    <small class="text-primary">Por asesor</small>
                    <canvas id="chart-area7"></canvas>
                    </div>
                </div> 
            </div> 
          </v-card-text>
  
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red" outlined @click="cerrar()"> Cerrar </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </template>
  
  <script> 
  export default {
      data() {
        return {
          loading: true,
          dialog: false,
          msg: '', 
          recibo: {},
          envio:{},
          grafico: null,
        };
      },
      methods: {
        async openmodal(data) { 
          this.dialog = true;
        //   window.console.log('--------',data);
          
          const da = window.Object.assign([], data);
          const conteoIntereses = {};

          da.forEach(x => {
            x.xfecha = x.fecha_registro.split(" ")[0];
            const nombreInteres = x.asesor;
            if (conteoIntereses[nombreInteres]) {
                     conteoIntereses[nombreInteres]++;
                } else {
                    conteoIntereses[nombreInteres] = 1;
                } 
            }); 

          window.console.log(data,conteoIntereses);
        if(this.grafico){
            this.grafico.destroy();
        }
          setTimeout(() => {
            this.crearGraficoGeneral(conteoIntereses);
          }, 400);
        },
        cerrar() { 
            this.dialog = false;
        },
        crearGraficoGeneral(conteoIntereses){ 
            const labeles = Object.keys(conteoIntereses);
            const datas = Object.values(conteoIntereses);
            const maxData = Math.max(...datas) + 0.5;
            
            const colores = ["#cde7f7","#6695bd"];
            for (let i = 0; i < datas.length; i++) {
                const colorIndex = i % colores.length; 
                colores.push(colores[colorIndex]);
            }

            const datosCombinados = datas.map((valor, index) => {
                return {
                    valor: valor,
                    label: labeles[index],
                    color: colores[index]
                };
            });

            datosCombinados.sort((a, b) => b.valor - a.valor);

            const datasOrdenadas = datosCombinados.map(item => item.valor);
            const labelesOrdenadas = datosCombinados.map(item => item.label);

            const config = {
                type: 'horizontalBar',
                data: {
                    datasets: [{ data: datasOrdenadas, backgroundColor: colores, label: 'Grafico General' }],
                    labels: labelesOrdenadas,
                },
                options: {
                    responsive: true,
                    scales: {
                        xAxes: [{
                            ticks: {
                                beginAtZero: true, 
                                max: maxData,
                                stepSize: 1
                            }
                        }]
                    },
                    tooltips: {
                        callbacks: {
                            label: function (tooltipItem, data) {  
                                var cant = data.datasets[0].data[tooltipItem.index] || '';
                                return cant;
                            },
                        },
                    },
                }, 
                plugins: [{
                    // Plugin para mostrar los labels dentro de las barras
                    afterDatasetsDraw: function(chart) {
                        var ctx = chart.ctx;
                        chart.data.datasets.forEach(function(dataset, i) {
                            var meta = chart.getDatasetMeta(i);
                            meta.data.forEach(function(bar, index) {
                                var data = dataset.data[index];
                                ctx.fillStyle = '#000000'; 
                                ctx.textAlign = 'center';
                                ctx.textBaseline = 'middle';
                                ctx.fillText(data, bar._model.x - 15, bar._model.y); // Ajustar posición
                            });
                        });
                    }
                }]
            }; 

            const idcanvas = "chart-area7"
            var ctx1 = document.getElementById(idcanvas).getContext('2d');
            this.grafico = new window.Chart(ctx1, config);
        },
        
      },
    };
  </script>
  